<div class="c__page-navigation-header">
  @if (!isDevice$ && showLogo) {
    <sd-icon name="icon-brand-xs-circle" />
  }

  @if (isDevice$ && product) {
    <sd-price [discountedPrice]="product.discountedPrice"
      [price]="product.price"
      [isSmall]="true"
      [isBundle]="isBundle"
      [recommendedPrice]="product?.recommendedPrice"
      [isSmallRecommendedPrice]="true"
      [isDiscountWithRecommendedPrice]="product?.isDiscountWithRecommendedPrice"
      [isSSR]="isSSR"
      (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
    />
  }

  @if (product?.isTaxesIncluded && isDevice$) {
    <p class="c__taxes-included is-caption">
      {{'product.taxesIncluded' | translate }}
    </p>
  }
</div>

<div class="c__page-navigation-content">
  @if (!isDevice$ && links) {
    <ul sd-list-inline class="is-l">
      @for (link of links; track $index) {
        <li #linksList>
          <a
            [href]="'#' + link.url"
            [sdSpyOn]="link.url"
            tabindex="0"
            (click)="selectLink(link.url, $event)"
            activeClass="is-active"
            class="is-reset is-body-m"
          >
            {{link.linkName}}
          </a>
        </li>
      }
      @if (animation === animationEnum.slide) {
        <div #activeBar class="c__active-bar"></div>
      }
    </ul>
  }

  @if (product) {
    <div class="c__price">
      @if (!isDevice$) {
        <sd-price
          [discountedPrice]="product.discountedPrice"
          [price]="product.price"
          [isSmall]="true"
          [isBundle]="isBundle"
          [recommendedPrice]="product?.recommendedPrice"
          [isSmallRecommendedPrice]="false"
          [isDiscountWithRecommendedPrice]="product?.isDiscountWithRecommendedPrice"
          [isSSR]="isSSR"
          (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
        />
      }
      @if (product?.isTaxesIncluded && !isDevice$) {
        <p class="c__taxes-included is-caption">
          {{'product.taxesIncluded' | translate }}
        </p>
      }
    </div>

    @if (showWishList && !isDevice$) {
      <button sd-button-icon
        type="button"
        icon="icon-heart-filled"
        (click)="addToFavorite()"
        [buttonIconTitle]="product.isInFavorite ? ('wishlist.remove' | translate)  + ' ' + product.title : ('wishlist.add' | translate) + ' ' + product.title"
        class="{{product.isInFavorite ? 'is-active' : 'is-unactive'}}"
      ></button>
    }

    @if (!product?.stock?.online && product.onSale && !!product.price) {
      <button sd-button type="button" [isSecondary]="true" (click)="stockNotify()">
        <span>{{'product.stock.notify' | translate}}</span>
        <span class="is-visually-hidden">{{product.title}}</span>
      </button>
    }

    @if (product?.stock?.online && product.onSale && !!product.price) {
      <button sd-button icon="icon-cart" (click)="addToCart()">
        <span>
          {{'actions.cart.add' | translate}}
          <span class="is-visually-hidden">{{product.title}}</span>
        </span>
      </button>
    }
  }
</div>
